var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleRankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9909 0.944523C10.9909 0.426591 10.5806 0 10.0742 0H0.907454C0.401031 0 0 0.433181 0 0.951112V8.9491C0 9.56413 0.157655 9.9747 0.50142 10.3263C0.845186 10.6778 4.85195 14.7283 4.85195 14.7283C5.20993 15.0906 5.79021 15.0906 6.14807 14.7283C6.14807 14.7283 10.105 10.7294 10.4701 10.3557C10.8355 9.98209 11 9.56062 11 8.93104C11 8.30158 10.9908 0.944576 10.9908 0.944576L10.9909 0.944523ZM7.79534 9.39064L5.50735 7.64034L3.21197 9.39064L4.12495 6.54384L1.83696 4.68755H4.58515L5.50365 1.87504L6.42585 4.68755H9.17404L6.88605 6.51986L7.79534 9.39064Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleRankIcon);
export default __webpack_public_path__ + "static/media/title-rank-icon.d2f1f138d811e3c31ccd9f8bf8ada5fb.svg";
export { ForwardRef as ReactComponent };